import React from 'react';
const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        {/* Letter E made with rectangles */}
        <g fill="currentColor">
          {/* Vertical bar */}
          <rect x="32" y="25" width="4" height="36" />
          {/* Top horizontal bar */}
          <rect x="32" y="25" width="16" height="4" />
          {/* Middle horizontal bar */}
          <rect x="32" y="41" width="12" height="4" />
          {/* Bottom horizontal bar */}
          <rect x="32" y="57" width="16" height="4" />
        </g>
      </g>
    </g>
  </svg>
);
export default IconLogo;
